import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
// v40 (2026-06-08): install the global fetch wrapper that injects
// X-Client-Platform / X-Client-Version / X-Client-Build on every API
// call. v39 added the headers inside apiClient.ts, but ~99% of fetches
// in this codebase use raw fetch() and bypassed it — so the admin
// /users page populated nothing. Wrapping globalThis.fetch fixes ALL
// call sites at once. See services/clientTelemetryHeaders.ts.
import { installClientTelemetryHeaders } from './services/clientTelemetryHeaders'
installClientTelemetryHeaders()

createRoot(document.getElementById('root')!).render(
  // 🚨 STRICTMODE DISABLED (Jan 21, 2026): Causing cascading reconciliation errors
  // Error: React Error #321, undefined props in NavigationProvider, MyPathContent, WorkoutDetail
  // StrictMode double-renders components which exposes race conditions in complex apps
  // TODO: Re-enable after refactoring state management
  <App />
)
/* Force deployment 1754337754 */
